<div class="rating">
  @for (star of stars(); track $index) {
    <div>
      <span class="rating__star rating__star--{{ star }}">
        <fr8bot-ui-icon [name]="star" [size]="16" />
      </span>
    </div>
  }
</div>

@if (showPoint()) {
  <div class="rating-point">
    {{ point() }}
  </div>
}
